import { capitalize, kebabCase } from 'lodash';

export const Capitalize = function (strLabel?: string | null): string | null | undefined {
  return strLabel && strLabel.charAt(0).toUpperCase() + strLabel.slice(1);
};

// Return type is `any` to match the legacy inferred surface: call sites feed the result into
// unions that would otherwise over-narrow (e.g. table formatter signatures).
export const UnderscoresToTitleCase = function (str?: string | null): any {
  if (!str) {
    return '';
  }
  const prepositions = ['a', 'an', 'the', 'and', 'but', 'or', 'on', 'to', 'is', 'for', 'in', 'with', 'of'];
  const regex = `/\b(${prepositions.join('|')}|([A-Z]\w*))\b/`;
  const htmlSplit = str.split('<').map(code => code.split('>'));
  const processedValue = htmlSplit.map(val => {
    if (val.length === 1) {
      return val[0]
        .split('_')
        .map((item, index) => {
          if (index === 0 || !item.match(regex)) {
            return item[0].toUpperCase() + item.slice(1);
          } else if (item.match(regex)) {
            return item;
          }
        })
        .join(' ');
    } else {
      return `<${val[0]}>${val[1]}`;
    }
  });

  return processedValue.join('');
};

// `str` stays `any`: legacy call sites pass non-string values (e.g. ReactNode) into lodash kebabCase.
export const Slugify = (str?: any): string => {
  str = str || '';
  str = kebabCase(str);
  str = str.replace(/[^a-zA-Z0-9\-\_]/g, '');
  return str.split('-').slice(0, 3).join('-');
};

export const KebabCase = (str?: string | null): string => {
  str = str || '';
  return kebabCase(str);
};

// The array is intentionally loosely typed (`any`): the sort comparator can return undefined for
// non-string/non-number members, which is a preserved legacy oddity.
export const AlphabetizeArrayOfObjects = (array: any[], key: string): any[] => {
  const arrayCopy: any = Array.from(array);

  if (!Array.isArray(arrayCopy)) return [];

  return arrayCopy.sort((value1: any, value2: any): any => {
    if (
      (typeof value1[key] === 'string' || typeof value1[key] === 'number') &&
      (typeof value2[key] === 'string' || typeof value2[key] === 'number')
    ) {
      const textA = value1[key].toString().toUpperCase();
      const textB = value2[key].toString().toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    }
  });
};

export const SplitFileName = (fileName: string): { extension: string | null; name: string } => {
  if (!fileName.includes('.')) {
    return { extension: null, name: fileName };
  }
  const splitName = fileName.split('.');
  const extension = `.${splitName.pop()}`;
  const name = splitName.join('.');
  return { extension, name };
};

export const ArrayToFormattedString = (array: any[], preposition = 'and'): string => {
  // ignore null, undefined and empty values
  const curatedArr = array.filter(item => item);

  // join list by commas (oxford syntax) and preposition
  const listStart = curatedArr.slice(0, -1).join(', ');
  const listEnd = curatedArr.slice(-1);
  const conjunction = curatedArr.length <= 1 ? '' : curatedArr.length > 2 ? `, ${preposition} ` : ` ${preposition} `;

  return [listStart, listEnd].join(conjunction);
};

export const StartCase = (string: string): string => string.replace(/\w+/g, capitalize);

export const EnsurePluralization = (
  str: string | null | undefined,
  count: number,
  suffix = 's'
): string | null | undefined => {
  if (str && count === 1 && str.slice(-1) === suffix) {
    return str.slice(0, -1);
  }
  return str && `${str}${count !== 1 && str.slice(-1) !== suffix ? suffix : ''}`;
};
